

































import { Vue, Component, Prop } from 'vue-property-decorator'
import Radio from './Radio/Radio.vue'
import Card from './Card.vue'
import Input from './Input/Input.vue'
import Checkbox from './Checkbox/Checkbox.vue'

@Component({
  components: {
    Card,
    Radio,
    Input,
    Checkbox
  }
})

export default class SelectCard extends Vue {
  @Prop({ required: true }) readonly toggleId!: string
  @Prop({ default: false }) readonly showOtherInput!: boolean
  @Prop({ required: true }) readonly labelText!: string
  @Prop({ required: false }) readonly radioGroupName!: string
  @Prop({ required: true }) readonly toggleType!: 'radio' | 'checkbox'
  @Prop({ default: false }) readonly checkboxChecked!: boolean;

  get isChecked (): boolean {
    return this.checkboxChecked || false
  }

  toggleChecked (e: Event) {
    this.$emit('chosen-input', this.toggleId)
    e.stopPropagation()
    if (this.toggleType === 'checkbox') e.preventDefault()
  }

  emitOtherTextInput (otherText: string) {
    this.$emit('other-text-input', otherText)
  }

  stopPropagation (event: Event) {
    event.stopPropagation()
  }
}
